/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */

// eslint-disable-next-line import/order, @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from 'styled-components';
import { halfGutterSize, minColumnWidth, responsiveThreshold } from './constants';

/**
 * Contains styles common to all columns
 */
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const baseColumnStyles = css`
	padding: 0 ${halfGutterSize}px;
	min-width: ${minColumnWidth}px;

	/**
   * Responsive behaviour:
   * - Fit available space
   * - Remove padding to fully utilise narrow screen real estate
   */
	@media (max-width: ${responsiveThreshold}px) {
		flex: 1 1;
		padding: 0;
	}
`;
